import { baseApi } from "redux/baseAPI";

export const documentApi = baseApi.injectEndpoints({
  tagTypes: ["Document"],
  endpoints: (builder) => ({
    getDocuments: builder.query({
      query: (params) => {
        return {
          url: `/documents/index.json`,
          method: "GET",
          params: params
        };
      },
      transformResponse: (response, meta, arg) => response.response.data,
      providesTags: ["Document"],
    }),
    getDocumentsCategories: builder.query({
      query: (params) => {
        return {
          url: `/documents/categories.json`,
          method: "GET",
          params: params
        };
      },
      transformResponse: (response, meta, arg) => {
        return response.response.data.map((item)=> {
            return item["Category"];
        });
      },
      providesTags: ["Document"],
    }),
    getUsersByPractice: builder.query({
      query: (params) => {
        return {
          url: `/users/all_by_practice.json`,
          method: "GET",
          params: params
        };
      },
      transformResponse: (response, meta, arg) => {
        return response.response.data;
      },
      providesTags: ["Document"],
    }),
    getProviders: builder.query({
      query: (params) => {
        return {
          url: `/providers.json`,
          method: "GET",
          params: params
        };
      },
      transformResponse: (response, meta, arg) => {
        return response.response.data?.map((res)=> res.User);
      },
    }),
    deleteDocument: builder.mutation({
      query: (data) => {
        return {
          url: `/documents/delete.json`,
          method: "POST",
          data
        };
      },
      transformResponse: (response, meta, arg) => {
        return response.response;
      },
      providesTags: ["Document"],
    }),
    saveDocument: builder.mutation({
      query: (data) => {
        return {
          url: `/documents/saveDocument.json`,
          method: "POST",
          data
        };
      },
      transformResponse: (response, meta, arg) => {
        return response.response;
      },
      invalidatesTags: ["Document"],
    }),
    addToPatientPortal: builder.mutation({
      query: (data) => {
        return {
          url: `/documents/add_to_patient_portal.json`,
          method: "POST",
          data
        };
      },
      transformResponse: (response, meta, arg) => response.response,
    }),
    removeFromPatientPortal: builder.mutation({
      query: (data) => {
        return {
          url: `/documents/remove_from_patient_portal.json`,
          method: "POST",
          data
        };
      },
      transformResponse: (response, meta, arg) => response.response,
    })
  }),
});

export const { useGetDocumentsQuery, useGetDocumentsCategoriesQuery, useGetUsersByPracticeQuery, useGetProvidersQuery, useDeleteDocumentMutation, useSaveDocumentMutation, useAddToPatientPortalMutation, useRemoveFromPatientPortalMutation } = documentApi;